import { type ReactNode, useCallback, useMemo, useState } from "react";

import { Context } from "../../lib/Context";
import { type MenuObject } from "../../model/types/contextMenu";

interface ProviderProps {
  children?: ReactNode;
}

export const Provider = ({ children }: ProviderProps) => {
  const [objects, setObjects] = useState<Map<string, MenuObject>>(new Map());

  const showById = useCallback((contextId: string, options: MenuObject) => {
    setObjects((prevState) => new Map(prevState.set(contextId, options)));
  }, []);

  const hideById = useCallback(
    (contextId: string) => {
      const prevState = new Map(objects);
      prevState.delete(contextId);
      setObjects(prevState);
    },
    [objects]
  );

  const defaultProps = useMemo(
    () => ({
      objects,
      showById,
      hideById,
    }),
    [objects, showById, hideById]
  );

  return <Context.Provider value={defaultProps}>{children}</Context.Provider>;
};
